import Vue from 'vue';
import weui from "weui.js";
import '@/style/weui.min.css'
import areaCode from '@/assets/json/areaCode'

/**
 * 时间范围
 */
weui.dateRangePicker = function (callback) {
    var begin, end;
    weui.datePicker({
        title: "选择开始时间",
        onConfirm: function (s) {
            begin = new Date(s[0].value, s[1].value - 1, s[2].value);
        },
        onClose: function () {
            if (begin) {
                weui.datePicker({
                    title: "选择结束时间",
                    onConfirm: function (e) {
                        end = new Date(
                            e[0].value,
                            e[1].value - 1,
                            e[2].value,
                            23,
                            59,
                            59
                        );
                        callback(begin, end);
                    }
                });
            }
        }
    });
}
/**
 * 期间范围
 */
weui.monthPicker = function (callback) {
    var date = new Date(),
        year = date.getFullYear(),
        years = [],
        month = date.getMonth() + 1,
        months = [],
        i,
        len;
    for (i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
            value: i,
            label: i + "年"
        });
    }
    for (i = 1, len = 12; i <= len; i++) {
        months.push({
            value: i,
            label: i + "月"
        });
    }

    weui.picker(years, months, [{ label: '至', value: '-' }], years, months, {
        title: "选择期间",
        defaultValue: [year, month, '-', year, month],
        onConfirm: function (r) {
            callback(r[0] * 100 + r[1], r[3] * 100 + r[4]);
        }
    });
}
/**
 * 号码所属地区
 */
areaCode.reverse().forEach((e, i) => {
    e.label = e.text + ' +' + e.value
    e.value = i
    delete e.text
});
weui.areaCodePicker = function(callback) {
    weui.picker(areaCode,
        {
            title: '选择地区',
            onConfirm: function (result) {
                callback(result)
            },
        }
    );
}

Vue.prototype.$weui = weui
/**
 * ajax请求+loading
 * @param {*} options 
 */
const loading = function (options) {
    var toast = weui.loading('加载中');
    return Vue.prototype.$ajax(options).then(function (res) {
        toast.hide();
        return res;
    });
};

Vue.prototype.$loading = loading